import _extends from "@babel/runtime/helpers/extends";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import { Animator } from 'wix-animations';
import PropTypes from 'prop-types';
import ChevronDown from 'wix-ui-icons-common/ChevronDown';
import ChevronUp from 'wix-ui-icons-common/ChevronUp';
import Text from '../../Text';
import Button from '../../Button';
import TextButton from '../../TextButton';
import { buttonTypes, dataHooks } from '../constants';
import style from './AccordionItem.st.css';

var AccordionItem = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(AccordionItem, _React$PureComponent);

  var _super = _createSuper(AccordionItem);

  function AccordionItem() {
    var _this;

    _classCallCheck(this, AccordionItem);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "state", {
      hover: false
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseLeave", function () {
      return _this.setState({
        hover: false
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_onMouseEnter", function () {
      return _this.setState({
        hover: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "_renderOpenButton", function () {
      var _this$props = _this.props,
          expandLabel = _this$props.expandLabel,
          buttonType = _this$props.buttonType,
          disabled = _this$props.disabled;
      var hover = _this.state.hover;
      var commonProps = {
        dataHook: dataHooks.toggleButton,
        disabled: disabled
      };
      var cases = [{
        when: function when() {
          return expandLabel && buttonType === buttonTypes.button;
        },
        make: function make() {
          return /*#__PURE__*/React.createElement(Button, _extends({}, commonProps, {
            size: "small",
            children: expandLabel
          }));
        }
      }, {
        when: function when() {
          return hover && expandLabel && buttonType === buttonTypes.textButton;
        },
        make: function make() {
          return /*#__PURE__*/React.createElement(TextButton, _extends({}, commonProps, {
            suffixIcon: /*#__PURE__*/React.createElement(ChevronDown, {
              size: "24px"
            }),
            children: expandLabel
          }));
        }
      }, {
        when: function when() {
          return true;
        },
        make: function make() {
          return /*#__PURE__*/React.createElement(TextButton, _extends({}, commonProps, {
            suffixIcon: /*#__PURE__*/React.createElement(ChevronDown, {
              size: "24px"
            })
          }));
        }
      }];
      return cases.find(function (_ref) {
        var when = _ref.when;
        return when();
      }).make();
    });

    _defineProperty(_assertThisInitialized(_this), "_renderCloseButton", function () {
      var _this$props2 = _this.props,
          collapseLabel = _this$props2.collapseLabel,
          buttonType = _this$props2.buttonType,
          disabled = _this$props2.disabled;
      var shouldRenderButton = collapseLabel && buttonType === buttonTypes.button;
      var commonProps = {
        disabled: disabled,
        children: collapseLabel,
        dataHook: dataHooks.toggleButton
      };
      return shouldRenderButton ? /*#__PURE__*/React.createElement(Button, _extends({}, commonProps, {
        priority: "secondary",
        size: "small"
      })) : /*#__PURE__*/React.createElement(TextButton, _extends({}, commonProps, {
        suffixIcon: /*#__PURE__*/React.createElement(ChevronUp, {
          size: "24px"
        })
      }));
    });

    return _this;
  }

  _createClass(AccordionItem, [{
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          icon = _this$props3.icon,
          title = _this$props3.title,
          open = _this$props3.open,
          children = _this$props3.children,
          onToggle = _this$props3.onToggle,
          disabled = _this$props3.disabled,
          skin = _this$props3.skin,
          hideShadow = _this$props3.hideShadow;
      var hover = this.state.hover;
      return /*#__PURE__*/React.createElement("div", style('root', {
        disabled: disabled,
        hover: hover,
        open: open,
        skin: skin,
        hideShadow: hideShadow
      }, this.props), /*#__PURE__*/React.createElement("div", {
        "data-hook": dataHooks.item
      }, /*#__PURE__*/React.createElement("div", {
        onClick: !disabled ? onToggle : null,
        className: style.header,
        "data-hook": "header",
        onMouseEnter: this._onMouseEnter,
        onMouseLeave: this._onMouseLeave
      }, icon && /*#__PURE__*/React.createElement("div", {
        className: style.icon,
        "data-hook": "icon"
      }, icon), title && /*#__PURE__*/React.createElement("div", {
        className: style.title,
        "data-hook": "titleContainer"
      }, typeof title === 'string' ? /*#__PURE__*/React.createElement(Text, {
        "data-hook": "title",
        ellipsis: true,
        weight: "normal"
      }, title) : title), /*#__PURE__*/React.createElement("div", {
        className: style.toggleButton,
        "data-hook": "toggle-accordion-wrapper",
        children: open ? this._renderCloseButton() : this._renderOpenButton()
      })), /*#__PURE__*/React.createElement(Animator, {
        show: open,
        height: true
      }, /*#__PURE__*/React.createElement("div", {
        "data-hook": "children",
        className: style.children
      }, children))));
    }
  }]);

  return AccordionItem;
}(React.PureComponent);

_defineProperty(AccordionItem, "displayName", 'AccordionItem');

_defineProperty(AccordionItem, "propTypes", {
  buttonType: PropTypes.oneOf(Object.values(buttonTypes)),
  title: PropTypes.node,
  expandLabel: PropTypes.node,
  collapseLabel: PropTypes.node,
  children: PropTypes.node,
  icon: PropTypes.node,
  open: PropTypes.bool,
  disabled: PropTypes.bool,
  onToggle: PropTypes.func,
  skin: PropTypes.oneOf(['standard', 'light']),
  hideShadow: PropTypes.bool
});

_defineProperty(AccordionItem, "defaultProps", {
  buttonType: buttonTypes.textButton
});

export default AccordionItem;